export default __webpack_public_path__ + "media/verification/title_locale_da-600c3a9d.png";